import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getAnneeScolaire } from 'app/entities/annee-scolaire/annee-scolaire.reducer';
import { StatusAnneeScolaire } from 'app/shared/model/anneeScolaire.model';
import { useEffect } from 'react';

export function useCheckIsAnneeInactive(anneeScolaireId: string) {
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (anneeScolaireId) {
      dispatch(getAnneeScolaire(anneeScolaireId));
    }
  }, [anneeScolaireId]);
  const status =
    anneeScolaire.statutAnneeScolaire === StatusAnneeScolaire.INACTIVE ||
    anneeScolaire.statutAnneeScolaire === StatusAnneeScolaire.CLOTUREE;
  return status;
}
